export const linkStyles = {
  a: {
    color: '-webkit-link',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}
